import './omgyum/style';
import FormStructure from './omgyum/form_structure';

export default FormStructure;